import { useContext } from 'react';

import NavBarContext, { NavBarContextProps } from './NavBarContext';

export type BreakpointName = 'xs' | 'slim' | 'sm' | 'md' | 'lg' | 'wide';

export const breakpointsMinWidthMap: Record<BreakpointName, number> = {
  xs: 320,
  slim: 480,
  sm: 768,
  md: 1024,
  lg: 1240,
  wide: 1440,
};

export const getMaxWidthBreakpointForMediaQuery = (
  breakpointName: BreakpointName,
): number => breakpointsMinWidthMap[breakpointName] - 1;

export const getResponsiveBreakpointClassName = (
  className: string,
  breakpointName: BreakpointName,
  includeBaseClass = true,
): string => {
  if (!includeBaseClass) {
    return `${className}_${breakpointName}`;
  }
  return `${className} ${className}_${breakpointName}`;
};

export const useResponsiveNavBar = (): NavBarContextProps => {
  const context = useContext(NavBarContext);

  if (context === undefined) {
    throw new Error(
      'useResponsiveNavBar must be used within a NavBarContext Provider',
    );
  }

  return context;
};
